// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__qsf-O","range":"MonthRangeSwitch_range__1v7Et","disabled":"MonthRangeSwitch_disabled__2pY2_"};